<template>
  <main>
    <app-header></app-header>
    <router-view></router-view>
    <app-footer></app-footer>
  </main>
</template>

<script>
import Header from './components/shared/Header'
import Footer from './components/shared/Footer'

export default {
  components: {
    AppHeader: Header,
    AppFooter: Footer
  },
  created () {
    this.$store.dispatch('autoLogin')
      .then(() => console.log('Log in automatically with success !'))
      .catch(() => console.log('Failed to log in automatically !'))
  }
}
</script>

<style>
  body{
    font-family: Arial, "Helvetica Neue", Helvetica, sans-serif;
    width: 90%;
    margin: 30px auto;
  }
  main{
    border: 1px solid var(--color-blue);
  }
  q {
    font-size: larger;
    color: var(--color-grey);
  }
  section{
    min-height: 450px;
  }
  label, .pLabel > span{
    color: var(--color-grey);
  }
</style>



// WEBPACK FOOTER //
// src/App.vue